/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoTravelCreate } from '../../models/dto-travel-create';
import { TravelItem } from '../../models/travel-item';

export interface TravelControllerSaveTravel$Params {
  id: number;
      body: DtoTravelCreate
}

export function travelControllerSaveTravel(http: HttpClient, rootUrl: string, params: TravelControllerSaveTravel$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerSaveTravel.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelItem;
      }>;
    })
  );
}

travelControllerSaveTravel.PATH = '/travel/{id}';
